export type WidgetElapsedMode = 'full' | 'compact' | 'hidden'

/** Reserve an hour-sized timer before it grows from mm:ss to hh:mm:ss. */
export function elapsedLayoutWidth(elapsed: string): number {
  return Math.max(8, elapsed.length)
}

/** Try shorter presentation before retiring any of the surrounding content. */
export function fitWidgetElapsed(root: HTMLElement, fits: (root: HTMLElement) => boolean, compactOnly = false): boolean {
  if (!root.querySelector('[data-widget-elapsed]')) return fits(root)
  for (const mode of (compactOnly ? ['compact'] : ['full', 'compact']) as WidgetElapsedMode[]) {
    root.dataset.elapsedMode = mode
    if (fits(root)) return true
  }
  return false
}
